const en = {
  sectionTitle: 'Customer Information',
  address: 'Address',
  created: 'Created',
};

const de = {
  sectionTitle: 'Kundeninformationen',
  address: 'Adresse',
  created: 'Erstellt',
};

const customerDetails = { en, de };
export default customerDetails;
